import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { GraphQLModule } from './graphql/graphql.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { LayoutModule } from './layout/layout.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NotificationModule } from './shared/notification/notification.module';
import { SkeletonScreenModule } from '@daysmart/angular-skeleton-screen';
import { CommonModule } from '@angular/common';
import { CookieModule } from 'ngx-cookie';
import { CheckTokensService } from './shared/check-tokens/check-tokens.service';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { LaunchDarklyService } from './services/launch-darkly-service/launch-darkly-service';
import { ConfigService } from './services/config/config.service';
import { APP_CONFIG } from './services/config/constants';

@NgModule({
    declarations: [AppComponent, PageNotFoundComponent],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LayoutModule,
        GraphQLModule,
        NotificationModule,
        SkeletonScreenModule,
        CookieModule.forRoot(),
        RecaptchaV3Module,
    ],
    exports: [],
    providers: [
        ConfigService,
        LaunchDarklyService,
        {
            provide: APP_INITIALIZER,
            useFactory: (
                checkTokensService: CheckTokensService,
                configService: ConfigService
            ) => () => {
                return checkTokensService.performCheck();
            },
            deps: [CheckTokensService, APP_CONFIG],
            multi: true,
        },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useFactory: (configService: ConfigService) => {
                return configService.config.reCaptchaSiteKey;
            },
            deps: [ConfigService, APP_CONFIG],
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
